import { useState } from "react";
import { Navigate, useNavigate, Link } from "react-router-dom";
import { Loader2, Lock } from "lucide-react";
import { useAdminAuth } from "@/context/AdminAuthContext";
import { useNoIndex } from "@/components/admin/ui";

export default function AdminLogin() {
  const { admin, login } = useAdminAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  useNoIndex();

  if (admin) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setErr(""); setBusy(true);
    try { await login(email, password); nav("/admin"); }
    catch (ex) { setErr(ex.message); }
    finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen bg-[var(--paper)] jali-bg flex items-center justify-center px-4" data-testid="admin-login-page">
      <form onSubmit={submit} className="w-full max-w-md bg-white rounded-3xl border border-[rgba(20,40,26,.08)] p-8 shadow-xl fade-up" data-testid="admin-login-form">
        <img src="/logo-horizontal.png" alt="Kindsaver" className="h-9" />
        <h1 className="mt-8 text-2xl sm:text-3xl font-bold flex items-center gap-2"><Lock size={22} className="text-[var(--leaf)]" /> Admin sign in</h1>
        <p className="text-sm text-[var(--ink-soft)] mt-2">For Kindsaver team members only.</p>
        <div className="mt-6 space-y-3">
          <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Email" autoComplete="username" data-testid="admin-login-email"
            className="w-full px-4 py-3 rounded-xl border border-[rgba(20,40,26,.12)] bg-[var(--paper)] text-sm focus:outline-none focus:ring-2 focus:ring-[var(--leaf)]/30" />
          <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Password" autoComplete="current-password" data-testid="admin-login-password"
            className="w-full px-4 py-3 rounded-xl border border-[rgba(20,40,26,.12)] bg-[var(--paper)] text-sm focus:outline-none focus:ring-2 focus:ring-[var(--leaf)]/30" />
        </div>
        {err && <div className="mt-3 text-sm text-red-600" data-testid="admin-login-error">{err}</div>}
        <button disabled={busy} className="btn-leaf w-full mt-6" data-testid="admin-login-submit">{busy && <Loader2 size={16} className="animate-spin" />} Sign in</button>
        <Link to="/" className="block text-center text-sm text-[var(--ink-soft)] mt-5 link-u" data-testid="admin-login-back">← Back to website</Link>
      </form>
    </div>
  );
}
